<ng-form #stepForm="ngForm"
         [ngSwitch]="resultsView">


    <p class="p1 m-t-9">{{'Find a collection point' | translate}}</p>
    <div *ngSwitchCase="true">
        <div
             class="flex flex-justify-between-x flex-justify-between-l flex-column-s flex-column-m flex-top-s flex-top-m">
            <p class="p2 col-11 m-t-1"
               *ngIf="resultsAddress">{{'Showing pick-up locations near %' | translate : resultsAddress}}</p>
            <button type="button"
                    (click)="reset()"
                    class="button-inline-2 p2 m-t-1-s m-t-1-m">{{'Change location' | translate}}</button>
        </div>

        <radio-group name="storeId"
                     class="m-t-6 m-t-5-s m-t-5-m block"
                     [(ngModel)]="currentStoreId">
            <ng-container *ngFor="let store of allowedStores | slice:0:limit; let first = first; trackBy: trackByStoreId">
                <radio3 class="w-12"
                        [ngClass]="{'m-t m-t-3-s m-t-3-m' : !first}"
                        [disabled]="saving"
                        (click)="onClick()"
                        [value]="store.id">

                    <p radioTitle>{{store.data?.store_name}}</p>
                    <p radioAside
                       *ngIf="store.data?.distance">
                        {{store.data.distance | number: '1.0-0'}}&nbsp;miles
                    </p>

                    <div class="m-t-5 m-t-2-s m-t-2-m"
                         *ngIf="currentStoreId === store.id"
                         radioBottom>
                        <p>
                            {{getStoreAddress(store)}}
                        </p>
                        <p *ngIf="store.data.phone"
                           class="p2 m-t-3">
                            {{'Tel' | translate}}:&nbsp;<a class="underline"
                               [attr.href]="'tel:' + store.data.phone">{{store.data.phone}}</a>
                        </p>
                    </div>

                </radio3>
            </ng-container>
        </radio-group>
        <input-wrap [messages]="{required: 'Please select collection point'}">
            <input type="hidden"
                   [(ngModel)]="currentStoreId"
                   name="currentStoreId"
                   required>
        </input-wrap>
        <button *ngIf="displayShowMore"
                type="button"
                class="button-inline m-t"
                [class.m-b]="!currentStoreId"
                (click)="showMore()"><span class="p1">{{'Show more' | translate}}</span></button>
        <action (click)="continue()"
                *ngIf="currentStoreId"
                class="button w-12 m-t-5"
                [class.busy]="saving">
            {{ 'Confirm' | translate }}
        </action>
    </div>
    <div *ngSwitchCase="false">
        <p class="p2 col-11 m-t-1">{{'Search a postcode, town or address' | translate}}</p>

        <input-wrap class="w-12 m-t-5">
            <input class="input"
                   (keyup.enter)="submit()"
                   type="text"
                   name="location"
                   [muiInput]="('Enter a postcode, town or address'| translate)"
                   [(ngModel)]="location"
                   required>
        </input-wrap>

        <action class="w-12 button m-t-5"
                (click)="submit()"
                [status]="loadStatus">
            {{'Search' | translate}}</action>
        <result [status]="loadStatus"></result>
        <action class="w-12 button-1 m-t-3"
                (click)="searchByGeolocation()"
                [status]="geoStatus">
            {{'Use my current location' | translate}}</action>
        <result [status]="geoStatus"></result>
    </div>

    <newsletter-checkboxes class="block"
                           *ngIf="!checkoutFormComponent.isSamples"
                           source="checkout"
                           [email]="checkoutFormComponent.email"
                           [checkoutData]="checkoutFormComponent.data"
                           [beforeSubmitSubject]="checkoutFormComponent.beforeSubmitSubject"
                           [variant]="'checkout'"></newsletter-checkboxes>

</ng-form>